<template>
  <div>
    <v-dialog width="500" max-width="100vw" v-model="changeCompanyDialog">
      <og-company-selector></og-company-selector>
    </v-dialog>
    <v-toolbar
      class="og-main-toolbar"
      light
      app
      :clipped-left="clipped"
      :fixed="fixed"
      :height="toolbarHeight"
    >
      <v-toolbar-side-icon class="ml-2" @click.stop="drawer = !drawer">
        <v-icon>mdi-menu</v-icon>
      </v-toolbar-side-icon>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-menu offset-y origin="center center" transition="scale-transition">
          <v-btn slot="activator" color="primary" class="white--text" depressed>
            <span class="text-capitalize">
              {{ accountName | truncate(20, '...') }}
            </span>
            <v-icon class="white--text ml-3" dark>mdi-account-circle-outline</v-icon>
          </v-btn>
          <v-card>
            <v-list>
              <v-list-tile @click="changeCompanyDialog = true">
                <v-list-tile-title>{{ $t('Cambiar entre mis empresas') }}</v-list-tile-title>
              </v-list-tile>
              <v-list-tile to="/user/myaccount">
                <v-list-tile-title>{{ $t('Configurar cuenta') }}</v-list-tile-title>
              </v-list-tile>
              <v-list-tile to="/user/myprofile">
                <v-list-tile-title>{{ $t('Datos de usuario') }}</v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="logout()">
                <v-list-tile-title>{{ $t('Salir') }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
    <v-navigation-drawer
      floating
      class="og-main-sidebar"
      width="200"
      mini-variant-width="65"
      persistent
      :mini-variant="miniVariant"
      :clipped="clipped"
      v-model="drawer"
      enable-resize-watcher
      app
    >
      <v-layout py-0 column fill-height>
        <v-list class="pa-0">
          <v-list-tile :style="{ height: toolbarHeight + 'px' }" class="grey lighten-2 elevation-1">
            <v-img
              v-if="miniVariant"
              contain
              :height="toolbarHeight - 10"
              src="/img/mini-logo.png"
            ></v-img>
            <v-img v-else contain :height="toolbarHeight - 10" src="/img/logo.png"></v-img>
          </v-list-tile>
        </v-list>

        <v-list>
          <slot v-if="$slots.topDrawerMenu" name="topDrawerMenu"></slot>
          <template v-for="(item, i) in toolbarItems">
            <div :key="i">
              <v-list-tile
                :to="item.path"
                v-if="
                  (!item.meta.admin || (item.meta.admin && $store.state.admin)) &&
                    !item.meta.accountMenu
                "
              >
                <v-list-tile-action class="pr-0">
                  <v-icon v-html="item.icon"></v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title
                    class="caption font-weight-medium"
                    v-text="item.name"
                  ></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-list
                class="py-0 pl-3"
                v-if="checkIfHasChildren(item) && checkIfCurrentSection(item.path)"
              >
                <template v-for="(subitem, j) in item.children">
                  <v-list-tile :key="j" :to="subitem.path" v-if="checkSubitemDrawer(subitem)">
                    <v-list-tile-action class="pr-0">
                      <v-icon v-html="subitem.icon"></v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title
                        class="caption font-weight-medium"
                        v-text="subitem.name"
                      ></v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </template>
              </v-list>
              <v-list
                class="py-0 pl-3"
                v-if="checkIfCurrentSection(item.path) && $slots.subSectionMenu"
              >
                <slot v-if="$slots.subSectionMenu" name="subSectionMenu"></slot>
              </v-list>
            </div>
          </template>
          <slot v-if="$slots.endDrawerMenu" name="endDrawerMenu"></slot>
        </v-list>
        <v-spacer></v-spacer>
        <!-- <v-list class="py-5">
                    <v-list-tile :style="{ height: miniVariant ? '36px' : '100px' }" class="text-xs-center py-0">
                        <v-img>
                            <v-icon :size="miniVariant ? '36px' : '100px'" color="secondary">mdi-lightbulb-on-outline</v-icon>
                        </v-img>
                    </v-list-tile>

                    <v-list-tile v-if="!miniVariant" class="pt-0">
                        <v-list-tile-content>
                            <v-list-tile-title class="text-xs-center">CENTRO DE AYUDA</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>


        </v-list>-->
      </v-layout>
    </v-navigation-drawer>
  </div>
</template>

<script>
import OgCompanySelector from '@/components/commons/OgCompanySelector.vue';
import AruRouteGuardMixin from '@/mixins/route-guards/AruRouteGuardMixin.js';

export default {
  mixins: [AruRouteGuardMixin],
  components: {
    OgCompanySelector,
  },
  data() {
    return {
      clipped: false,
      drawer: false,
      fixed: false,
      toolbarHeight: 50,
      miniVariant: false,
      changeCompanyDialog: false,
    };
  },
  mounted() {
    console.log({
      slots: this.$slots,
    });
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    accountName() {
      let companyName = null;
      if (
        this.$store.state.hasOwnProperty('clavedat') &&
        this.$store.state.hasOwnProperty('user') &&
        this.$store.state.user.hasOwnProperty('customer_profile') &&
        this.$store.state.user.customer_profile &&
        this.$store.state.user.customer_profile.hasOwnProperty('fiscal_data') &&
        Array.isArray(this.$store.state.user.customer_profile.fiscal_data)
      ) {
        this.$store.state.user.customer_profile.fiscal_data.forEach(company => {
          // console.log({ COMPANY: company });
          if (company.CLAVEDAT == this.$store.state.clavedat) {
            companyName = company.APELNOM;
          }
        });
      }
      return companyName ? companyName : this.user.name;
    },
    currentRoute() {
      return this.$router.currentRoute.fullPath;
    },
    toolbarItems() {
      let items = [];
      this.$router.options.routes.forEach(element => {
        if (
          element.hasOwnProperty('meta') &&
          element.meta.hasOwnProperty('toolbar') &&
          element.meta.toolbar &&
          this.userHasPermissions(element)
        ) {
          items.push(element);
        }
      });
      return items;
    },
    drawerItems() {
      let result = [];

      this.toolbarItems.forEach(element => {
        if (element.path.startsWith('/' + this.section)) {
          console.log(element.children);
          element.children.forEach(item => {
            if (
              item.hasOwnProperty('meta') &&
              item.meta.hasOwnProperty('drawer') &&
              item.meta.drawer === true &&
              this.userHasPermissions(element)
            ) {
              result.push(item);
            }
          });
        }
      });

      return result;
    },

    section() {
      let section = '';
      let segments = this.$router.currentRoute.fullPath.split('/');
      if (Array.isArray(segments) && segments[1]) {
        section = segments[1];
      }

      return section;
    },
  },
  methods: {
    checkIfCurrentSection(path) {
      return path.startsWith('/' + this.section);
    },
    checkSubitemDrawer(subitem) {
      // return true;
      console.log('subitem');
      console.log(subitem);
      let res =
        subitem.hasOwnProperty('meta') &&
        subitem.meta.hasOwnProperty('drawer') &&
        subitem.meta.drawer === true &&
        this.userHasPermissions(subitem);
      console.log({ RES: res });
      return res;
    },
    checkIfHasChildren(item) {
      return item.hasOwnProperty('children') && item['children'].length > 0;
    },
    logout: function() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/login');
      });
    },
  },
};
</script>

<style lang="scss"></style>
